<script setup lang="ts">
import {computed} from "vue";

const props = defineProps({
  height: {
    type: Number,
    default: 41
  }
})

const height = computed(() => props.height ? props.height : 41)
const width = computed(() => height.value * 50 / 64)

</script>

<template>
  <svg :width="width" :height="height" viewBox="0 0 50 64"
       xmlns="http://www.w3.org/2000/svg"
       xml:space="preserve"
       style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;">
    <g transform="matrix(1,0,0,1,-7.254,0)">
        <path
          d="M32.34,23.556C30.254,23.42 25.426,23.108 25.426,18.76C25.426,13.515 32.376,13.515 34.986,13.515C39.57,13.515 45.508,14.868 49.748,16.138C49.748,16.138 52.114,16.972 54.128,17.826L54.315,17.876L54.315,3.5L54.058,3.424C49.05,1.684 43.232,0 32.444,0C13.844,0 7.254,10.835 7.254,20.118C7.254,25.468 9.547,38.064 30.85,39.518C32.655,39.618 37.447,39.905 37.447,44.396C37.447,48.096 33.524,50.292 26.925,50.292C19.695,50.292 12.675,48.449 8.415,46.7L8.415,61.495C14.796,63.164 21.985,64 30.414,64C48.6,64 56.747,53.748 56.747,43.587C56.747,32.067 47.632,24.58 32.34,23.555"
          style="fill:rgb(134,37,101);fill-rule:nonzero;"/>
    </g>
</svg>
</template>

<style scoped lang="less">

</style>
